import React, { useEffect, useState } from 'react';
import { View, Text, Pressable, ScrollView } from 'react-native';
import { StyleSheet, useUnistyles } from 'react-native-unistyles';
import { getRecents } from '@/utils/recentlyVisited';
import FileIcon from '@/components/Files/FileIcon';

const CARD_WIDTH = 110;

const RecentFiles = ({ onPress }) => {
  const { theme: { colors, fonts } } = useUnistyles();
  const [recents, setRecents] = useState([]);

  useEffect(() => {
    getRecents().then(all => {
      const files = all.filter(r => r.type === 'file').slice(0, 10);
      setRecents(files);
    });
  }, []);

  if (recents.length === 0) return null;

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>
        Recently Opened
      </Text>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.scroll} keyboardShouldPersistTaps="handled"
>
        {recents.map(item => (
          <Pressable
            key={item.id}
            onPress={() => onPress(item)}
            style={styles.card}
          >
            <View style={styles.iconWrap}>
              <FileIcon extension={item.extension} mimeType={item.mimeType} size={36} />
            </View>
            <Text style={styles.name} numberOfLines={2}>
              {item.filename}
            </Text>
            {item.size ? (
              <Text style={styles.meta}>
                {item.extension?.replace('.', '').toUpperCase()}{item.size ? `, ${formatSize(item.size)}` : ''}
              </Text>
            ) : null}
          </Pressable>
        ))}
      </ScrollView>
    </View>
  );
};

const formatSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const styles = StyleSheet.create(({colors, fonts}) => ({
  container: {
    paddingTop: 10,
    paddingBottom: 12,
  },
  heading: {
    fontSize: 12,
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: 10,
    color: colors.textSecondary, 
    fontFamily: fonts.body
  },
  scroll: {
    gap: 10,
  },
  card: {
    width: CARD_WIDTH,
    borderRadius: 12,
    padding: 10,
    gap: 6,
    backgroundColor: colors.surface,
  },
  iconWrap: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 44,
  },
  name: {
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 16,
    color: colors.text, 
    fontFamily: fonts.body,
  },
  meta: {
    fontSize: 11,
    color: colors.textSecondary, 
    fontFamily: fonts.body,
  },
}));

export default RecentFiles;
